/* 夏侯淵傳共用的小工具：關右的人物（通用招式）、各族的兵、會走的糧車、圍營
 * 糧車不是單位（打不到、不擋路），是 m.folk：沿路走或跟著人走；敵人貼在旁邊就停下、耐久下降，歸零就被劫。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop } from '../kit.ts';

const NC = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, weapon, look, skills) => H(id, name, sub, 'neutral', '戰士', weapon, Object.assign({ fx: '#ffd8a0' }, look, { c: Object.assign({}, NC, look.c) }), skills);
export const XHY = {
  changxi: P('changxi', '昌豨', '東海賊帥', 'axe', { eye: 'fierce', beard: 'bushy', bulk: 1.15, size: 1.1, c: { armor: '#5a5040', cloth: '#4a4034', cape: '#6a5a3a', plume: '#9a8a60' } }, [
    ['山斧', 'crescent', '造成 {110/110/110/110} 傷害。'], ['蠻衝', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['旋斧', 'spin', '每圈 {50/50/50/50} 傷害。'], ['據險', 'slam', '{150/150/150} 傷害。']]),
  hansui: P('hansui', '韓遂', '字文約', 'spear', { beard: 'long', hair: '#c8c4bc', bulk: 1.1, size: 1.08, c: { armor: '#6a3a2a', cloth: '#4a2a20', cape: '#8a4a2a', plume: '#c0703a' } }, [
    ['涼州槍', 'crescent', '造成 {120/120/120/120} 傷害。'], ['羌騎', 'charge', '衝撞造成 {100/100/100/100} 傷害。'], ['迴槍', 'spin', '每圈 {55/55/55/55} 傷害。'], ['老將', 'slam', '{170/170/170} 傷害。']]),
  songjian: P('songjian', '宋建', '河首平漢王', 'sword', { head: 'guan', eye: 'fierce', beard: 'goatee', bulk: 1.1, size: 1.1, c: { armor: '#7a2a2a', cloth: '#5a1a1a', cape: '#a0302a', plume: '#e0b040', trim: '#e0b040' } }, [
    ['王劍', 'crescent', '造成 {120/120/120/120} 傷害。'], ['突陣', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['迴劍', 'spin', '每圈 {55/55/55/55} 傷害。'], ['僭號', 'slam', '{160/160/160} 傷害。']]),
  chengxiang: P('fuhan-xiang', '丞相', '宋建所置', 'staff', { head: 'guan', beard: 'long', c: { armor: '#5a3a30', cloth: '#6a2a24', cape: null } }, [
    ['符', 'bolt', '{80/80/80/80}'], ['令', 'crescent', '造成 {70/70/70/70} 傷害。'], ['守', 'shield', '護身。'], ['詔', 'slam', '{110/110/110} 傷害。']]),
};
export const XTROOPS = {
  bandit: troop('donghai-bandit', '昌豨兵', { armor: '#5a5040', sleeve: '#4a4034', cloth: '#4a4034', plume: '#7a6a50' }),
  yuan: troop('yuan-straggler', '潰兵', { armor: '#7a5a2a', sleeve: '#5a4220', cloth: '#5a4220', plume: '#d0a040' }),
  qiang: troop('qiang-soldier', '羌兵', { armor: '#6a5a4a', sleeve: '#5a4232', cloth: '#5a4232', plume: '#c08a50' }),
  di: troop('di-soldier', '氐兵', { armor: '#4a5a4a', sleeve: '#3a4a3a', cloth: '#3a4a3a', plume: '#8aa070' }),
  liang: troop('liang-soldier', '涼州兵', { armor: '#6a3a2a', sleeve: '#4a2a20', cloth: '#4a2a20', plume: '#c0503a' }),
};
// 一般敵兵的數值（m.foe('huangjin', x, y, F(...)) 用）
export const F = (spec, name, hp = 420, atk = 24, ms = 245) => ({ spec, name, hp, maxHp: hp, atk, ms });

// ---- 糧車 ----
// o.path：沿著走的路（走到底就 arrived）；o.follow：跟著這個單位走（保持 o.gap 的距離）；sp：速度
export function cart(m, x, y, o) {
  return m.folk(x, y, Object.assign({ name: '糧車', still: true, near: 1, draw: cartDraw, hp: 100, sp: 120, pi: 0, gap: 130, cart: true }, o || {}));
}
// 每格 dt：移動、被貼身就停下與受損。回傳這一格新到站或被劫的車
export function cartsTick(m, w, dt, list, dps = 4) {
  const out = { arrived: [], lost: [] };
  for (const c of list) {
    if (c.gone) continue;
    const foes = w.units.filter((u) => u.alive && u.team === 1 && !u.untargetable && !u.rout && SG.gd(u.x, u.y, c.x, c.y) < 220);
    c.held = foes.length > 0;
    const near = foes.filter((u) => SG.gd(u.x, u.y, c.x, c.y) < 130).length;
    if (near) { c.hp -= near * dps * dt; c.hit = true; }
    if (c.hp <= 0) { c.gone = true; c.lost = true; out.lost.push(c); m.folks = m.folks.filter((f) => f !== c); continue; }
    if (c.held) continue;
    let goal = null;
    if (c.path) goal = c.path[c.pi];
    else if (c.follow && c.follow.alive && SG.gd(c.x, c.y, c.follow.x, c.follow.y) > c.gap) goal = [c.follow.x, c.follow.y];
    if (!goal) continue;
    const dx = goal[0] - c.x, dy = goal[1] - c.y, L = Math.hypot(dx, dy), s = c.sp * dt;
    if (c.path && L <= s) { c.x = goal[0]; c.y = goal[1]; if (++c.pi >= c.path.length) { c.gone = true; c.arrived = true; out.arrived.push(c); m.folks = m.folks.filter((f) => f !== c); } continue; }
    if (!c.path && L - c.gap < s) continue;
    c.x += (dx / L) * s; c.y += (dy / L) * s; c.f = dx < 0 ? -1 : 1;
  }
  return out;
}
// 沿著一條折線切出比較密的點（糧車照這些點走）
export function along(pts) { const out = [pts[0]]; for (let i = 1; i < pts.length; i++) { const a = pts[i - 1], b = pts[i], n = Math.max(1, Math.round(Math.hypot(b[0] - a[0], b[1] - a[1]) / 200)); for (let k = 1; k <= n; k++) out.push([a[0] + ((b[0] - a[0]) * k) / n, a[1] + ((b[1] - a[1]) * k) / n]); } return out; }

function cartDraw(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y); ctx.scale(f.f || 1, 1);
  SG.draw.castShadow(ctx, 0, 4, 52, 12, 80, 0.3);
  poly(ctx, [[-46, -12], [46, -12], [46, -30], [-46, -30]], '#7a5634', 2);
  for (const x of [-28, 28]) { ctx.beginPath(); ctx.arc(x, -6, 13, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-40, -30], [-2, -30], [-4, -58], [-38, -58]], '#c9b07a', 1.6);
  poly(ctx, [[2, -30], [40, -30], [36, -52], [6, -52]], '#b89a64', 1.6);
  ctx.fillStyle = '#5a3a22'; ctx.font = '900 16px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('糧', -21, -38);
  ctx.restore();
  if (f.hp < 100) { // 耐久條
    ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fillRect(f.x - 36, f.y - 78, 72, 7);
    ctx.fillStyle = f.hp > 50 ? '#d8b860' : '#d05a3a'; ctx.fillRect(f.x - 35, f.y - 77, 70 * Math.max(0, f.hp) / 100, 5);
  }
  if (f.held) { ctx.fillStyle = '#ff6040'; ctx.font = '900 18px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('！', f.x, f.y - 86 + Math.sin(T * 8) * 3); }
}

// ---- 圍營、羌屯：帳篷加旗（f.flag 旗上的字，f.col 布色，f.burnt 燒過變黑）----
export function campDraw(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 70, 16, 80, 0.3);
  const col = f.burnt ? '#2a2420' : f.col || '#3b5a99';
  poly(ctx, [[-60, 0], [60, 0], [0, -70]], col, 2.2);
  poly(ctx, [[-14, 0], [14, 0], [0, -30]], '#2a2018', 1.4);
  if (!f.burnt && f.flag) {
    SG.draw.caps(ctx, [[[70, 0], [70, -120], 4, '#5b3d27']]);
    const wv = Math.sin(T * 3) * 4;
    poly(ctx, [[72, -118], [118, -114 + wv], [116, -84 + wv], [72, -88]], f.flagCol || '#c0302a', 1.6);
    ctx.fillStyle = '#f2e6c8'; ctx.font = '900 20px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(f.flag, 94, -100 + wv / 2);
  }
  ctx.restore();
}
